export default __webpack_public_path__ + "static/qi-927d71eedf951745128d2d152b9ba2c1.jpg";